import React from "react";

import {Dropdown} from "primereact/dropdown";

import './style.scss'

const DropdownUi = ({ value = '', options = [], onChange = (any) => {}, optionLabel = '', optionValue = '', placeholder = '', label = '', id = 'dropdown', className = '', type = '', disabled = false, invalid = false, emptyMessage }) => {
    return (
        <div className={`dropdown-container ${className}`}>
            {label ? <label htmlFor={id} className='dropdown-container__label'>{label}</label> : null}
            <Dropdown id={id} value={value} options={options} onChange={onChange} optionValue={optionValue} optionLabel={optionLabel} placeholder={placeholder} className={`dropdown ${type} ${invalid ? 'p-invalid' : ''}`} disabled={disabled} emptyMessage={emptyMessage} appendTo={'self'} />
        </div>
    )
}

export default DropdownUi